import React from 'react';
import styles from './pmndp-enhanced.module.css';

export const PMNDPFormField = ({ 
  label, 
  type = 'text', 
  value, 
  onChange, 
  onBlur,
  error, 
  placeholder, 
  required = false,
  options = [],
  rows = 3,
  ...props 
}) => {
  const fieldId = `field-${Math.random().toString(36).substr(2, 9)}`;
  
  const renderInput = () => {
    switch (type) {
      case 'select':
        return (
          <select
            id={fieldId}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            {...props}
          >
            <option value="">{placeholder || `Select ${label}`}</option>
            {options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        );
      
      case 'textarea':
        return (
          <textarea
            id={fieldId}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            rows={rows}
            {...props}
          />
        );
      
      default:
        return (
          <input
            id={fieldId}
            type={type}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
            {...props}
          />
        );
    }
  };

  return (
    <div className={`${styles['pmndp-form-field']} ${error ? styles['error'] : ''}`}>
      <label htmlFor={fieldId}>
        {label}
        {required && <span style={{ color: '#ef4444', marginLeft: '4px' }}>*</span>}
      </label>
      {renderInput()}
      {error && (
        <div className={styles['error-message-modal']}>
          {error}
        </div>
      )}
    </div>
  );
};

export const PMNDPFormSection = ({ title, icon, children }) => {
  return (
    <div className={styles['pmndp-form-section']}>
      <div className={styles['pmndp-form-section-header']}>
        {icon && (
          <div className={styles['pmndp-form-section-icon']}>
            <i className={`fa ${icon}`}></i>
          </div>
        )}
        <h3 className={styles['pmndp-form-section-title']}>{title}</h3>
      </div>
      <div className={styles['pmndp-form-grid']}>
        {children}
      </div>
    </div>
  );
};

export const PMNDPFormButtons = ({ 
  onSave, 
  onCancel, 
  saveText = 'Save', 
  cancelText = 'Cancel',
  isLoading = false,
  disabled = false 
}) => {
  return (
    <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
      <button 
        type="button"
        className={`${styles['pmndp-btn']} ${styles['pmndp-btn-secondary']}`} 
        onClick={onCancel}
        disabled={isLoading}
      >
        <i className="fa fa-times"></i>
        {cancelText}
      </button>
      <button 
        type="submit"
        className={`${styles['pmndp-btn']} ${styles['pmndp-btn-primary']}`} 
        onClick={onSave}
        disabled={disabled || isLoading}
      >
        {isLoading ? (
          <i className="fa fa-spinner fa-spin"></i>
        ) : (
          <i className="fa fa-check"></i>
        )}
        {isLoading ? 'Saving...' : saveText}
      </button>
    </div>
  );
};
